import { useUserMetrics } from '@features/user/store/hooks';

/**
 * Hook to check if the user has created their first note.
 * This is used to determine which cards to show on the dashboard.
 */
export const useFirstNoteStatus = () => {
  const userMetrics = useUserMetrics();
  
  // Loading state when metrics haven't been fetched yet
  const isLoading = userMetrics === undefined;
  
  // Check if user has created at least one note
  const hasCreatedFirstNote = userMetrics ? userMetrics.notes_created > 0 : false;
  
  return {
    hasCreatedFirstNote,
    isLoading,
    notesCreated: userMetrics?.notes_created ?? 0,
  };
};